<template>

  <ais-index
    :index-name="indexNames"
    :searchClient='customSearchClient'
    :stalledSearchDelay='10000'
    :stalled-search-delay='10000'>
    <search-engine-page searchPanel="press"/>

  </ais-index>
</template>

<script>
import { customSearchClient } from '../../algolia/customsearch.js'
import AisIndex from '../AisComponents/AisIndex'
import SearchEnginePage from '../SearchEnginePage'

export default {
  name: 'PressPage',
  data () {
    return {
      indexNames: process.env.VUE_APP_ALGOLIA_ARTICLES_INDEX_NAME,
      customSearchClient
    }
  },
  components: {
    AisIndex,
    SearchEnginePage
  }
}
</script>
